// The restore ack names no table, so waiters are answered in the order they asked.
const waiting: ((ok: boolean) => void)[] = [];

/** Waits for the next restore ack; `cancel` hands it back to the toast. */
export function awaitRestoreAck() {
  const { promise: ok, resolve } = Promise.withResolvers<boolean>();
  waiting.push(resolve);
  return {
    ok,
    cancel: () => {
      const at = waiting.indexOf(resolve);
      if (at >= 0) waiting.splice(at, 1);
    },
  };
}

/** Answers the oldest waiter; false when nobody waits, so the caller toasts. */
export function settleRestoreAck(ok: boolean): boolean {
  const settle = waiting.shift();
  settle?.(ok);
  return !!settle;
}
